export const COMPONENT_KEY =
  'talent-employee-pid-dashboard-or-my-team-component';
